/* eslint-disable react/no-multi-comp, react/prop-types */
import { reduxForm } from 'redux-form';
import React from 'react';
import _ from 'lodash';
import classNames from 'classnames';

import { ApplyButton, SecondaryButton } from 'components/widgets/buttons';
import { Form } from 'components/forms/form-structure';
import { isMobile } from 'constants';
import SVG from 'components/widgets/icons/svg';

import DefaultFilter, * as FilterComponents from './filter-components';


// Component
class FilterForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = { showAdvanced: false };
    this.debounceSubmit = _.debounce(() => {
      this.props.handleSubmit();
    }, 200);

    this.submit = (e) => {
      this.props.handleSubmit(e);
      this.close();
    };

    this.toggle = () => this.setState({ showAdvanced: !this.state.showAdvanced });
    this.close = () => this.setState({ showAdvanced: false });
    this.open = () => this.setState({ showAdvanced: true });
  }

  render() {
    const { showAdvanced } = this.state;
    const { config, initialize, currentValues, menuAlert } = this.props;
    const allFields = _.flatten(config.advanced);
    const advanced = _.difference(allFields, config.basic);
    const defaults = _.isFunction(config.defaults) ? config.defaults() : config.defaults;

    return (
      <Form onSubmit={this.submit} customSubmitArea>
        { !showAdvanced && !isMobile &&
          <div className="basic-filters">
            { config.advanced && !!config.advanced.length &&
              <div>
                <SecondaryButton className="expand-filters" onClick={this.toggle}>
                  <SVG src="svg/filter.svg" className="filter" />
                  { menuAlert }
                  <SVG src="svg/expand.svg" className="filter" />
                </SecondaryButton>
              </div>
            }
            {_.map(config.basic, field => getFilterComponent(field, allFields, currentValues, false, this.debounceSubmit))}
            {_.map(config.autoFilters, (filterSet, index) =>
              <div className="auto-filter-set" key={index}>
                {_.map(filterSet, filter => <SecondaryButton key={filter.label} onClick={filter.fn} className={classNames({ active: filter.active(currentValues || {}) })}>{filter.label}</SecondaryButton>)}
              </div>
            )}
            <div onClick={this.open} className="flex rendered-advanced-filters">
              {_.map(advanced, filter => {
                if (!currentValues || !currentValues[filter]) return null;

                return getFilterComponent(filter, allFields, currentValues, true, null, currentValues[filter]);
              })}
            </div>
          </div>
        }

        { isMobile && !showAdvanced &&
          <div className="basic-filters">
            { config.advanced && !!config.advanced.length &&
              <SecondaryButton className="expand-filters" onClick={this.toggle}>
                <SVG src="svg/filter.svg" className="filter" />
                { menuAlert }
                <SVG src="svg/expand.svg" className="filter" />
              </SecondaryButton>
            }
            {_.map(config.basic, field => getFilterComponent(field, allFields, currentValues, false, this.debounceSubmit))}
          </div>
        }

        { showAdvanced &&
          <div className="advanced-filters">
            <div className="flex">
              {_.map(config.autoFilters, (filterSet, index) =>
                <div className="auto-filter-set" key={index}>
                  {_.map(filterSet, filter => <SecondaryButton key={filter.label} onClick={filter.fn} className={classNames({ active: filter.active(currentValues || {}) })}>{filter.label}</SecondaryButton>)}
                </div>
              )}
            </div>
            <div className="filter-elements">
              {_.map(config.advanced, (fields, index) =>
                <div key={index}>
                  {_.map(fields, field => getFilterComponent(field, allFields, currentValues, _.includes(advanced, field)))}
                </div>
              )}
            </div>
            <div className="submit-area">
              <SecondaryButton onClick={this.toggle}><SVG src="svg/filter.svg" className="filter" /><SVG src="svg/collapse.svg" className="filter" /></SecondaryButton>
              { !isMobile && <SecondaryButton onClick={() => initialize(defaults)}>Reset to Defaults</SecondaryButton> }
              <SecondaryButton onClick={() => initialize({})}>Clear</SecondaryButton>
              <ApplyButton />
            </div>
          </div>
        }
      </Form>
    );
  }
}

// Exports
export default reduxForm({
  form: 'filterForm',
  // Turn off destroy on unmount because the filter form is unmounted when the user switches tabs or
  // closes the right pane, & the user would lose any changes to filters that they hadn't applied.
  // Instead, the filterForm section of the store will be destroyed by the removeFilters filter action
  // (when the user switches pages)
  destroyOnUnmount: false,
  enableReinitialize: true,
  warn: (values) => {
    if (!values) return {};
    
    const warnings = {};
    if (!_.isEmpty(values.id)) warnings.id = 'Other filters will be ignored';
    return warnings;
  }
})(FilterForm);


// Helper function
function getFilterComponent(field, fields, values, advanced, debounceSubmit, renderValue) {
  const Filter = FilterComponents[_.upperFirst(field)] || DefaultFilter;
  const props = { name: field };
  const company = _.get(values, 'company');
  const reliesOnCompany = _.includes(['ticket', 'agreement', 'multiAgreement'], field);

  if (company && reliesOnCompany) props.company = Number(company);
  if (!FilterComponents[_.upperFirst(field)]) props.label = _.startCase(field);

  if (!advanced && debounceSubmit) props.onChange = debounceSubmit;
  if (advanced && renderValue) props.renderValue = renderValue;

  return (
    <div key={field} className={advanced ? 'advanced-filter' : 'basic-filter'}>
      <Filter {...props} />
    </div>
  );
}
